/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import FormBaseComponentEmpty from './FormBaseComponentEmpty.vue'

export * from './FormBaseComponentEmpty.vue'
export default FormBaseComponentEmpty
